export default "__VITE_ASSET__BZ9vz7o3__"